import * as React from 'react';
import { Paragraph } from '../../../../elements';
import TwoColRow from './TwoColRow';
const PartnerBackgroundCheckRow = ({ value, i18n, formatDate }) => {
    const shouldHaveDefaultDescription = value.comment === '' && value.description === '';
    return (React.createElement(React.Fragment, null,
        shouldHaveDefaultDescription ?
            (React.createElement(Paragraph, null, i18n('readreport.default.partnerbackgroundcheckdescription'))) :
            (React.createElement(TwoColRow, { label: `${i18n('common.description')}:`, value: value.description })),
        React.createElement(TwoColRow, { label: i18n('common.verifiedwith'), value: `${i18n('readreport.informationsource.PartnerBackgroundCheck')} (${formatDate(value.verificationDate)})` }),
        value.comment !== '' && (React.createElement("div", { className: 'ReadReportContent__Notation ReadReportContent__Space--large' },
            React.createElement(Paragraph, { bold: true }, i18n('common.note')),
            React.createElement("div", { className: 'ReadReportContent__NotationContent' },
                React.createElement(Paragraph, { className: 'ReadReportContent__Space--semi-medium ReadReportContent__Space--scroll-overflow' }, value.comment))))));
};
export default PartnerBackgroundCheckRow;
